import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ca8df474"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "readme-box"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_4 = {
  class: "title"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_6 = {
  class: "title"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_8 = {
  class: "title"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_10 = {
  class: "title"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_12 = {
  class: "title"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_14 = {
  class: "title"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_16 = {
  class: "title"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_18 = {
  class: "title"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_20 = {
  class: "title"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_22 = {
  class: "title"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_24 = {
  class: "title"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_26 = {
  class: "title"
};
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_28 = {
  class: "title"
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_30 = {
  class: "title"
};
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_32 = {
  class: "title"
};
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_34 = {
  class: "title"
};
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_36 = {
  class: "title"
};
const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_38 = {
  class: "title"
};
const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
import { _langforSpark } from '@/utils/langforSpark';
// let json = {
//         status:'evaluate',
//         data:{
//           version_code:'',
//           appId:'',
//           query:''
//         }
//       }
//     const receiveJsonFromFlutterWithCallback = (res: any)=>{
//         console.log(res,'————传递JSON返回结果_____')
//       };
// const handleClick = ()=>{
//   let res = jsFlutterBridge_sendJsonToH5WithCallback.postMessage(JSON.stringify(json))
//   console.log(res,'————传递JSON返回结果')
// }
// const handleClickNoJson = ()=>{
//   let noJson = jsFlutterBridge_sendJsonToH5WithCallback.postMessage(JSON.stringify(''))
//   console.log(noJson,'—————不传递JSON返回结果')
// }
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("p", null, [_createElementVNode("span", _hoisted_2, _toDisplayString(_unref(_langforSpark)('readmeUpdateTit')), 1), _hoisted_3, _createTextVNode(" " + _toDisplayString(_unref(_langforSpark)('readmeUpdatebox')), 1)]), _createElementVNode("p", null, [_createElementVNode("span", _hoisted_4, _toDisplayString(_unref(_langforSpark)('specialReminderTit')), 1), _hoisted_5, _createTextVNode(" " + _toDisplayString(_unref(_langforSpark)('specialReminderBox1')), 1)]), _createElementVNode("p", null, _toDisplayString(_unref(_langforSpark)('specialReminderBox2')), 1), _createElementVNode("p", null, [_createElementVNode("span", _hoisted_6, _toDisplayString(_unref(_langforSpark)('overviewTit')), 1), _hoisted_7, _createTextVNode(" " + _toDisplayString(_unref(_langforSpark)('overviewBox1')), 1)]), _createElementVNode("p", null, [_createElementVNode("span", _hoisted_8, _toDisplayString(_unref(_langforSpark)('applicationTit')), 1), _hoisted_9, _createTextVNode(" " + _toDisplayString(_unref(_langforSpark)('applicationBox1')), 1)]), _createElementVNode("p", null, [_createElementVNode("span", _hoisted_10, _toDisplayString(_unref(_langforSpark)('registrationTit')), 1), _hoisted_11, _createTextVNode(" " + _toDisplayString(_unref(_langforSpark)('registrationBox1')), 1)]), _createElementVNode("p", null, [_createElementVNode("span", _hoisted_12, _toDisplayString(_unref(_langforSpark)('contentPolicyTit')), 1), _hoisted_13, _createTextVNode(" " + _toDisplayString(_unref(_langforSpark)('contentPolicyBox1')), 1)]), _createElementVNode("p", null, [_createElementVNode("span", _hoisted_14, _toDisplayString(_unref(_langforSpark)('behaviorTit')), 1), _hoisted_15, _createTextVNode(" " + _toDisplayString(_unref(_langforSpark)('behaviorBox1')), 1)]), _createElementVNode("p", null, [_createElementVNode("span", _hoisted_16, _toDisplayString(_unref(_langforSpark)('paymentTermsTit')), 1), _hoisted_17, _createTextVNode(" " + _toDisplayString(_unref(_langforSpark)('paymentTermsBox1')), 1)]), _createElementVNode("p", null, [_createElementVNode("span", _hoisted_18, _toDisplayString(_unref(_langforSpark)('thirdPartyTit')), 1), _hoisted_19, _createTextVNode(" " + _toDisplayString(_unref(_langforSpark)('thirdPartyBox1')), 1)]), _createElementVNode("p", null, [_createElementVNode("span", _hoisted_20, _toDisplayString(_unref(_langforSpark)('changeTit')), 1), _hoisted_21, _createTextVNode(" " + _toDisplayString(_unref(_langforSpark)('changeBox1')), 1)]), _createElementVNode("p", null, [_createElementVNode("span", _hoisted_22, _toDisplayString(_unref(_langforSpark)('disclaimerTit')), 1), _hoisted_23, _createTextVNode(" " + _toDisplayString(_unref(_langforSpark)('disclaimerBox1')), 1)]), _createElementVNode("p", null, [_createElementVNode("span", _hoisted_24, _toDisplayString(_unref(_langforSpark)('limitationTit')), 1), _hoisted_25, _createTextVNode(" " + _toDisplayString(_unref(_langforSpark)('limitationBox1')), 1)]), _createElementVNode("p", null, [_createElementVNode("span", _hoisted_26, _toDisplayString(_unref(_langforSpark)('compensationTit')), 1), _hoisted_27, _createTextVNode(" " + _toDisplayString(_unref(_langforSpark)('compensationBox1')), 1)]), _createElementVNode("p", null, [_createElementVNode("span", _hoisted_28, _toDisplayString(_unref(_langforSpark)('intellectualTit')), 1), _hoisted_29, _createTextVNode(" " + _toDisplayString(_unref(_langforSpark)('intellectualBox1')), 1)]), _createElementVNode("p", null, [_createElementVNode("span", _hoisted_30, _toDisplayString(_unref(_langforSpark)('privacyTit')), 1), _hoisted_31, _createTextVNode(" " + _toDisplayString(_unref(_langforSpark)('privacyBox1')), 1)]), _createElementVNode("p", null, [_createElementVNode("span", _hoisted_32, _toDisplayString(_unref(_langforSpark)('agreementTit')), 1), _hoisted_33, _createTextVNode(" " + _toDisplayString(_unref(_langforSpark)('agreementBox1')), 1)]), _createElementVNode("p", null, [_createElementVNode("span", _hoisted_34, _toDisplayString(_unref(_langforSpark)('choiceTit')), 1), _hoisted_35, _createTextVNode(" " + _toDisplayString(_unref(_langforSpark)('choiceBox1')), 1)]), _createElementVNode("p", null, [_createElementVNode("span", _hoisted_36, _toDisplayString(_unref(_langforSpark)('effectivenessTit')), 1), _hoisted_37, _createTextVNode(" " + _toDisplayString(_unref(_langforSpark)('effectivenessBox1')), 1)]), _createElementVNode("p", null, [_createElementVNode("span", _hoisted_38, _toDisplayString(_unref(_langforSpark)('contactTit')), 1), _hoisted_39, _createTextVNode(" " + _toDisplayString(_unref(_langforSpark)('contactBox1')), 1)])]);
    };
  }
});